(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_462351f"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('camperig-deferred-youtube')) {
    customElements.define('camperig-deferred-youtube', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button || this.initialized) return;
        this.initialized = true;
        button.addEventListener('click', () => {
          const frame = document.createElement('iframe');
          frame.src = 'https://www.youtube.com/embed/' + encodeURIComponent(this.dataset.videoId) + '?autoplay=1';
          frame.title = this.dataset.videoTitle;
          frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          frame.allowFullscreen = true;
          this.replaceChildren(frame);
          frame.focus();
        }, { once: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
